import React, { useState } from "react";
import formatNumberWithCommas from "../../../core/utils/formatNumberWithCommas";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
// @mui material components
import TableContainer from "@mui/material/TableContainer";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import { useAuth } from "context";
import MDBadge from "components/MDBadge";
import { ADDITIONAL_POINTS_BADGES } from "core/constant";
function AdditionalPointsMobile({ additionalPointsForMobile }) {
  const [openModal, setOpenModal] = useState(null);
  const { darkMode } = useAuth();
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    bgcolor: !darkMode ? "background.paper" : "#202940",
    boxShadow: 10,
    p: 4,
    borderRadius: 2,
    "@media (max-width:767px)": {
      width: "95%",
      padding: `32px 8px`,
    },
  };

  return (
    <TableContainer sx={{ boxShadow: "none" }}>
      <MDBox>
        {additionalPointsForMobile?.map((data, index) => {
          return (
            <React.Fragment key={index}>
              <MDBox
                sx={{ p: 2, borderBottom: "1px solid gray", cursor: "pointer" }}
                onClick={() => setOpenModal(data.id)}
              >
                <MDBox
                  sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                  <MDTypography sx={{ fontWeight: "500" }}>
                    {data.restaurantName
                      ? data.restaurantName.length > 10
                        ? `${data.restaurantName.slice(0, 10)}...`
                        : data.restaurantName
                      : "-"}
                  </MDTypography>
                  <MDTypography sx={{ fontSize: "16px" }}>{data.processedDate || "-"}</MDTypography>
                </MDBox>
                <MDBox
                  sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                  <MDBox sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                    <MDTypography sx={{ fontSize: "16px" }}>
                      {formatNumberWithCommas(data.cashbackPoints)}
                    </MDTypography>
                  </MDBox>
                  <MDTypography sx={{ fontSize: "16px" }}>
                    <MDBadge
                      badgeContent={data.status}
                      color={ADDITIONAL_POINTS_BADGES[data?.cashbackStatus]}
                      variant="gradient"
                      size="lg"
                    />
                  </MDTypography>
                </MDBox>
              </MDBox>
              <Modal
                open={openModal === data.id}
                onClose={() => setOpenModal(null)}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
              >
                <Box sx={style}>
                  <card>
                    <MDBox
                      pt={1}
                      px={1}
                      sx={{ display: "flex", justifyContent: "space-between", fontSize: "14px" }}
                    >
                      <MDTypography sx={{ fontSize: "15px" }}>RESTAURANT NAME</MDTypography>
                      <MDTypography sx={{ textAlign: "end", fontSize: "15px" }}>
                        {data.restaurantName || "-"}
                      </MDTypography>
                    </MDBox>

                    <MDBox pt={1} px={1} sx={{ display: "flex", justifyContent: "space-between" }}>
                      <MDTypography sx={{ fontSize: "15px" }}>PROCESSED DATE</MDTypography>
                      <MDTypography sx={{ textAlign: "end", fontSize: "15px" }}>
                        {data.processedDate || "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox pt={1} px={1} sx={{ display: "flex", justifyContent: "space-between" }}>
                      <MDTypography sx={{ fontSize: "15px" }}>CASHBACK POINTS</MDTypography>
                      <MDTypography sx={{ textAlign: "end", fontSize: "15px" }}>
                        {formatNumberWithCommas(data.cashbackPoints)}
                      </MDTypography>
                    </MDBox>
                    <MDBox pt={1} px={1} sx={{ display: "flex", justifyContent: "space-between" }}>
                      <MDTypography sx={{ fontSize: "15px" }}>REASON</MDTypography>
                      <MDTypography sx={{ textAlign: "end", fontSize: "15px" }}>
                        {data.reason || "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox pt={1} px={1} sx={{ display: "flex", justifyContent: "space-between" }}>
                      <MDTypography sx={{ fontSize: "15px" }}>STATUS</MDTypography>
                      <MDTypography sx={{ textAlign: "end", fontSize: "15px" }}>
                        <MDBox ml={-1}>
                          <MDBadge
                            badgeContent={data.status}
                            color={ADDITIONAL_POINTS_BADGES[data?.cashbackStatus]}
                            variant="gradient"
                            size="lg"
                          />
                        </MDBox>
                      </MDTypography>
                    </MDBox>
                  </card>
                </Box>
              </Modal>
            </React.Fragment>
          );
        })}
      </MDBox>
    </TableContainer>
  );
}

// Typechecking props for the AdditionalPointsMobile
AdditionalPointsMobile.propTypes = {
  additionalPointsForMobile: PropTypes.any,
};

export default AdditionalPointsMobile;
